import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../configs/firebaseconfig'; // Adjust the import according to your project structure

const AdminScreen = ({ language }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      localStorage.setItem('user', JSON.stringify({ email: user.email, role: 'admin' }));

      alert('Logged in successfully');
      navigate('/manageprojects');
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="text-center py-10">
      <h1 className="text-4xl font-bold">{language === 'en' ? 'Admin' : 'ยินดีต้อนรับสู่หน้าหลัก'}</h1>
      <form onSubmit={handleLogin} className="mt-8">
        <div>
          <label htmlFor="email" className="block text-lg">{language === 'en' ? 'Email' : 'อีเมล'}</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-2 p-2 border border-gray-300"
          />
        </div>
        <div className="mt-4">
          <label htmlFor="password" className="block text-lg">{language === 'en' ? 'Password' : 'รหัสผ่าน'}</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-2 p-2 border border-gray-300"
          />
        </div>
        
        <button type="submit" className="mt-6 ml-auto mr-auto  px-4 py-2 bg-blue-500 text-white rounded w-20">
          {language === 'en' ? 'Login' : 'เข้าสู่ระบบ'}
        </button>
        
      </form>
      {error && <p className="text-red-500 mt-20">{error}</p>}
    </div>
  );
};

export default AdminScreen;